
<div v-if="visible" class="outer-carousel">
  <Transition name="pop" appear>
    <div v-if="visible" class="modal" role="dialog">
      <div class="modal-overlay">
        <div class="card-carousel">
          <div class="card-img">
            <img :src="currentImage" alt="" />
            <div v-show="displayControls" class="actions">
              <span class="prev" @click="prevImage"> &#8249; </span>
              <span class="next" @click="nextImage"> &#8250; </span>
            </div>
          </div>
          <button v-show="displayControls" class="btn-close-modal" @click="closeModal">X</button>
          <div v-if="activeThumbnails" class="thumbnails">
            <div
              v-for="(image, index) in images"
              :key="index"
              :class="['thumbnail-image', focusedPosition === index ? 'active' : '']"
              @click="activateImage(index)"
            >
              <img :src="image" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</div>
